export default "__VITE_ASSET__5d44c32f__"